/* global axios */
import ApiClient from './ApiClient';

// Not a CRUD resource: a bot session is an attribute of a conversation, reached through it.
class BotSessions extends ApiClient {
  constructor() {
    super('conversations', { accountScoped: true });
  }

  show(conversationId) {
    return axios.get(`${this.url}/${conversationId}/bot_session`);
  }

  pause(conversationId) {
    return axios.post(`${this.url}/${conversationId}/bot_session/pause`);
  }

  resume(conversationId) {
    return axios.post(`${this.url}/${conversationId}/bot_session/resume`);
  }

  // Devolve a conversa ao bot quando não há sessão para retomar — depois de uma transferência,
  // o que volta é a responsabilidade.
  handback(conversationId) {
    return axios.post(`${this.url}/${conversationId}/bot_session/handback`);
  }
}

export default new BotSessions();
